export const getColorsForGraph = (dataItem: string) => {
  const defaultColors = {
    threshold: '#888888',
  };
  switch (dataItem) {
    case 'Normal':
      return {
        ...defaultColors,
        typical: '#0d784d',
        latest: '#2ae79b',
      };
    case 'High-Normal':
      return {
        ...defaultColors,
        typical: '#604b08',
        latest: '#ffc501',
      };
    case 'Outlier':
      return {
        ...defaultColors,
        typical: '#8a003c',
        latest: '#dc0462',
      };
    default:
      return {
        ...defaultColors,
        typical: '#0d784d',
        latest: '#2ae79b',
      };
  }
};
